<template>
    <a-spin tip="Carregando..." :spinning="spinning">
        <div class="container">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined/>
                            <a href="/configurations/procedure-types"><span>Tipos de Processo</span></a>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>
                            Alterar Tipo de Processo
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <a-row style="display: flex; justify-content: space-between; margin: 20px; width: 100%;">
                    <a-col :span="8" style="display: flex; align-items: center; width: 30%;">
                        <strong style="margin-right: 10px;">Nome:</strong>
                        <a-input v-model:value="procedure.name" style="width: 100%" disabled/>
                    </a-col>

                    <a-col :span="14" style="display: flex; align-items: center; width: 60%;">
                        <strong style="margin-right: 10px;">Processo Externo:</strong>
                        <a-select
                            v-model:value="procedure.external_procedure_type_ids"
                            mode="multiple"
                            style="width: 100%"
                            placeholder="Selecione"
                            show-search
                            optionFilterProp="label"
                            :options="externalProcedureTypes"
                        >
                        </a-select>


                    </a-col>
                </a-row>

                <a-row style="margin-left:20px">
                    <a-col :span="16" style="display:flex;gap:5px">
                        <a-tooltip title='Salvar Alterações' >
                            <a-button size="large" type="primary" @click="save" class="center-flex">
                                <template #icon>
                                    <SaveOutlined style="font-size: 18px;"/>
                                </template>
                            </a-button>
                        </a-tooltip>
                    </a-col>
                </a-row>
            </a-card>
        </div>
    </a-spin>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {FileOutlined, SaveOutlined} from '@ant-design/icons-vue';
import {notification} from 'ant-design-vue';
import axios from "axios";
import { openNotification } from "../../../../utils/utilities";
const props = defineProps(["id"]);
const spinning = ref(false);
const procedure = reactive({
    id: null,
    name: '',
    external_procedure_type_ids: [],
});

const externalProcedureTypes = ref([])
const filterOption = (input, option) => {
    console.log(input, option.children);
    return option.children.toLowerCase().includes(input.toLowerCase());
};

const route = '/api/configurations/procedure-types';
const save = async () => {
    try {
        spinning.value = true
        await axios.put(route + `/${procedure.id}`, procedure);
        spinning.value = false
        window.location.href = `/configurations/procedure-types/`
    } catch (error) {
        spinning.value = false
        openNotification('error', error.message)
    }
}

const getExternalProcedureTypes = async () => {
    externalProcedureTypes.value = (await axios.get('/api/e-cidade/procedure/types')).data.data.map(procedure => {
        return {
            value: procedure.p51_codigo,
            label: `${procedure.p51_codigo} - ${procedure.p51_descr}`
        }
    });
}

onMounted(async () => {
    await getExternalProcedureTypes();
    if (props.id) {
        try {
            spinning.value = true
            let register = (await axios.get(`${route}/${props.id}`)).data.data
            spinning.value = false
            procedure.id = register.id
            procedure.name = register.name
            procedure.external_procedure_type_ids = register.external_types.map(pr => pr.p51_codigo)
            spinning.value = false
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    }
})
</script>
<style scoped>
.center-flex {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
